import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../App";
import { Plus, FolderKanban, ChevronRight } from "lucide-react";

const STATUS_COLORS = { NotStarted: "#64748B", InProgress: "#3B82F6", Blocked: "#EF4444", Done: "#22C55E" };

export default function ProjectsListPage() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/projects?me=true").then(r => setProjects(r.data || [])).catch(console.error).finally(() => setLoading(false)); }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-pulse text-[var(--t3)] text-xl font-heading">LOADING...</div></div>;

  return (
    <div className="max-w-4xl mx-auto space-y-5" data-testid="projects-list">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl text-[var(--t1)]">PROJECTS</h1>
        <button onClick={() => navigate("/projects/new")} className="flex items-center gap-2 px-4 py-2 bg-[var(--r)] text-white text-sm font-bold rounded-full hover:bg-[var(--r)] transition-colors">
          <Plus size={16} /> New Project
        </button>
      </div>
      <div className="space-y-3">
        {projects.length === 0 ? (
          <div className="text-center py-16"><FolderKanban size={40} className="mx-auto text-[#333] mb-3" /><p className="text-[#555] text-sm">No projects yet. Create your first project.</p></div>
        ) : (
          projects.map(p => (
            <button key={p.project_id} onClick={() => navigate(`/projects/${p.project_id}`)} className="w-full text-left glass-card p-4 hover:border-[var(--bdrh)] transition-colors group">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-white font-medium text-sm">{p.title}</p>
                  <div className="flex items-center gap-3 mt-1 text-xs">
                    <span style={{ color: STATUS_COLORS[p.status] || "#666" }}>{p.status}</span>
                    {p.due_date && <span className="text-[#555]">Due: {p.due_date}</span>}
                  </div>
                </div>
                <ChevronRight size={16} className="text-[#333] group-hover:text-[#666]" />
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
